/**
 * @desc 查询铁质材料需求季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/wap/plan/quarter/queryPlanFerrousMaterial',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/quarter/queryPlanFerrousMaterial',
    data,
  });
}
